import { IListaStatusEtapa } from "../../../Interfaces/Repasse/StatusEtapa/StatusEtapaInterface";
import {
    CriarStatusPorTipoCasoService,
    DeletarStatusPorTipoCasoService,
    EditarStatusEtapaService,
    ListarStatusPorTipoCasoService,
} from "../../../Services/Geral/StatusEtapa/StatusEtapaServices";
import { Controller } from "../../Controller";

export async function ListarStatusPorTipoCasoController(idTipoCaso: number) {
    return Controller(ListarStatusPorTipoCasoService(idTipoCaso));
}

export async function EditarStatusEtapaController(
    requestBody: IListaStatusEtapa
) {
    return Controller(EditarStatusEtapaService(requestBody));
}

export async function DeletarStatusPorTipoCasoController(
    idStatusEtapa: number
) {
    return Controller(DeletarStatusPorTipoCasoService(idStatusEtapa));
}

export async function CriarStatusPorTipoCasoController(
    requestBody: IListaStatusEtapa
) {
    return Controller(CriarStatusPorTipoCasoService(requestBody));
}
